import { useState, useEffect } from 'react'; 
import { useMediaQuery } from 'react-responsive';

import { useStepContext } from "../../utils/StepContext.jsx"
import { useFormContext } from "../../utils/FormContext.jsx"
import { useAuth } from "../../utils/AuthContext/AuthContext.jsx"

import MainCard from "../MainCard.jsx";
import ProgressBar from '../ProgressBar/ProgressBar.jsx';
import SaveButton from '../SaveButton.jsx';
import PDFPreview from '../PDFPreview.jsx';
import HelpButton from '../HelpButton.jsx';
import ShishitoAssist from '../ShishitoAssist/ShishitoAssist.jsx';  

const PriceTerms2 = () => {

    const { handleNext, handleBack, markStepAsComplete, unsetStepAsComplete } = useStepContext();
    const { formData, formId, handleLoanTypeChange, handleLoanTypeOtherInputChange, handleSellerConcessionChange, handleEarnestMoneyPayableChange } = useFormContext(); 
    const [autoSetOther, setAutoSetOther] = useState(false);
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const { token, user } = useAuth(); // Use user and token from context
    const [isAssistVisible, setIsAssistVisible] = useState(false);

    const currentPageValue = 1;
    const currentSubStepProgress = 3/3; 

    const onBack = () => {
        unsetStepAsComplete(currentPageValue);
        handleBack();
    };

    const onNext = () => {
            markStepAsComplete(currentPageValue); // Mark this step as complete
            handleNext(); // Navigate to the next step
    };

    const toggleAssist = () => {
        setIsAssistVisible(!isAssistVisible);
    };

    return (
        <div className="w-full flex flex-col items-center">
        {/* <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress}/> */}

    {/* <div className='flex w-full'> */}
        <MainCard width={750}>
        <div className="inline-flex w-full justify-between">
        {isMobile ? <h3 className="text-black text-[18px] text-left font-normal font-['Inter']">Price & terms</h3> : <h3 className="text-black text-xl text-left font-normal font-['Inter']">Price & terms</h3>}
            <div className='gap-2 md:gap-4 items-center inline-flex'>
                <HelpButton onClick={toggleAssist}/>
                <SaveButton formData={formData} formId={formId}/>
                {user && <PDFPreview formData={formData}/> }
            </div>
        </div>
            {/* SELLER CONCESSION */}
            <div className="flex flex-col text-left justify-start gap-2 items-start w-[375px] md:w-[750px] px-6">
                
                    <div className="w-full justify-between gap-2 items-start flex flex-col mb-4">
                        <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Seller Concession?</span>
                        <span className='text-sm text-slate-600'>
                                Typically used if you are asking for help to cover items such as closing costs, inspection fees, repairs, or other expenses.
                        </span>
                    </div>
                    <div className="w-[40vh] h-auto md:h-[39px] flex items-center bg-white rounded-md border border-slate-300 focus-within:border-blue-500 focus-within:border-2">
                            <div className="pl-2 text-slate-500 font-semibold font-['Inter']">$</div>
                        <input 
                            className="text-left pl-2 w-[230px] focus:outline-none focus:border-transparent"
                            type="text"
                            name="sellerConcession"
                            value={formData.sellerConcession}
                            onChange={handleSellerConcessionChange}
                        />
                </div>
            </div>
            
            <div className="flex w-full justify-center gap-10 md:gap-36 mt-2 bg-white">
                <button className="w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-center md:items-start flex" onClick={handleBack}>
                    Back
                </button>
                <button className="w-[100px] md:w-[150px] justify-center items-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 md:items-start flex" onClick={onNext}>
                    Next
                </button>
            </div>
        </MainCard>
        {isAssistVisible && (
                <div className="w-full md:w-auto absolute bottom-1 md:right-4">
                    <ShishitoAssist onClose={toggleAssist}/>
                </div>
            )}
        </div>
        
    )
}

export default PriceTerms2; 